import apiClient from "@/api/index";
import router from "@/router";

export const reportGameProgressModule = {
    namespaced: true,

    state: () => ({
        reportData: {},
        reportLoading: true,
        filterset: {},
        filtersetLoading: true,
        filterSpecs: {},
        excelData: {},
    }),

    mutations: {
        setReportData(state, data) {
            console.log(data);
            state.reportData = data;
            state.reportLoading = false;
        },

        setReportFilterset(state, data) {
            state.filterSpecs['shop'] = []

            if(Object.keys(router.currentRoute.value.query).length == 0) {
                console.log('!');
                for(let filter in data) {
                    if(filter !== 'title') {
                        for(let i = 0; i < data[filter].choices.length; i++) {
                            if(filter === 'date_range') {
                                state.filterSpecs[filter].push(data[filter].choices[i].value)
                            } else {
                                if(data[filter].choices[i].checked) {
                                    state.filterSpecs[filter].push(data[filter].choices[i].value)
                                }
                            }
                        }
                    }
                }
            } else {
                const queries = router.currentRoute.value.query
                
                if(queries.shop) {
                    if(Array.isArray(queries.shop)) {
                        state.filterSpecs['shop'] = queries.shop
                    } else {
                        state.filterSpecs['shop'] = [Number(queries.shop)]
                    }
                }
            }
            
            state.filterset = data
            state.filtersetLoading = false
        },

        setExcelData(state, data) {
            state.excelData = data;
        },
    },

    actions: {
        async getReportData({ commit, state }) {
            state.reportLoading = true;
            // Проверяет, есть ли параметры которые можно передать в запросе
            if (router.currentRoute.value.fullPath.split("?")[1]) {
                try {
                    const response = await apiClient.get(
                        "/reports/game_progresses/data?" +
                            router.currentRoute.value.fullPath.split("?")[1],
                        {
                            headers: {
                                Authorization: "Token " + localStorage.getItem("token"),
                            },
                        }
                    );
                    commit("setReportData", response.data.data);
                    commit("setExcelData", response.data);
                } catch (err) {
                    // Если есть ошибка
                    alert(err);
                }
                // Если нет, делать запрос без параметров
            } else {
                try {
                    const response = await apiClient.get("/reports/game_progresses/data", {
                        headers: {
                            Authorization: "Token " + localStorage.getItem("token"),
                        },
                    });
                    commit("setReportData", response.data.data);
                    commit("setExcelData", response.data);
                } catch (err) {
                    // Если есть ошибка
                    alert(err);
                }
            }
        },

        async getReportFilterset({ commit }) {
            try {
                const response = await apiClient.get("/reports/game_progresses/filterset", {
                    headers: {
                        Authorization: "Token " + localStorage.getItem("token"),
                    },
                });
                commit("setReportFilterset", response.data);
            } catch (err) {
                // Если есть ошибка
                console.log(err)
            }
        },

        async getExcelFile({ state }) {
            try {
                const response = await apiClient.post(
                    "/reports/export_to_excel/",
                    state.excelData,
                    {
                        headers: {
                            Authorization: "Token " + localStorage.getItem("token"),
                        },
                        responseType: "blob",
                    }
                );
                const now = new Date();
                const url = URL.createObjectURL(response.data);
                const a = document.createElement("a");
                a.href = url;
                a.download = `${state.excelData.title}_${now.toLocaleDateString()}.xls`;
                a.style.display = "none";
                document.body.appendChild(a);
                a.click();
                a.remove();
                URL.revokeObjectURL(url);
            } catch (err) {
                // Если есть ошибка
                alert(err);
            }
        },
    },
};
